







(function(){
const badgeCache = {};
const productCache = {};
const wishlistBadgeCache = {};
const wishlistBadgeLoading = {};

async function loadWishlistBadge(card, handle) {

  if (!handle) return;

  const media = card.querySelector(".wls-card-media");
  if (!media) return;

  /* Already exists */
  if (media.querySelector(".gr-wishlist-product-badge")) {
    return;
  }

  /* Already loading */
  if (wishlistBadgeLoading[handle]) {
    return;
  }

  wishlistBadgeLoading[handle] = true;

  try {

    let badgeHTML = wishlistBadgeCache[handle];

    /* --------------------------------
       GET ORIGINAL THEME BADGE HTML
    -------------------------------- */

    if (!badgeHTML) {

      const response = await fetch(
        "/products/" + handle,
        {
          credentials: "same-origin"
        }
      );

      if (!response.ok) return;

      const html = await response.text();

      const parser = new DOMParser();

      const doc = parser.parseFromString(
        html,
        "text/html"
      );

      const themeBadge =
        doc.querySelector(
          ".product-badges.product-badges--top-left"
        ) ||
        doc.querySelector(
          ".product-badges"
        );

      if (!themeBadge) return;

      badgeHTML = themeBadge.outerHTML;

      wishlistBadgeCache[handle] = badgeHTML;
    }


   /* --------------------------------
   OUTER POSITIONING WRAPPER
-------------------------------- */

const wrapper =
  document.createElement("div");

wrapper.className =
  "gr-wishlist-product-badge";

wrapper.style.cssText = `
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: auto !important;
  bottom: auto !important;
  z-index: 50 !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  pointer-events: none !important;
  display: block !important;
`;


/* --------------------------------
   SHADOW DOM
   APP WISHLIST CSS CANNOT OVERRIDE
-------------------------------- */

const shadow =
  wrapper.attachShadow({
    mode: "open"
  });


/* --------------------------------
   THEME STYLES INSIDE SHADOW DOM
-------------------------------- */

/* Load all theme CSS files */
document
  .querySelectorAll('link[rel="stylesheet"]')
  .forEach(link => {

    const clone =
      document.createElement("link");

    clone.rel = "stylesheet";
    clone.href = link.href;

    shadow.appendChild(clone);

  });


/* Copy inline theme styles */
document
  .querySelectorAll("style")
  .forEach(style => {

    const clone =
      document.createElement("style");

    clone.textContent =
      style.textContent;

    shadow.appendChild(clone);

  });


/* --------------------------------
   ORIGINAL THEME BADGE HTML
-------------------------------- */

const badgeContainer =
  document.createElement("div");

badgeContainer.innerHTML =
  badgeHTML;


/* --------------------------------
   FORCE THEME BADGE VARIABLES
   ONLY INSIDE WISHLIST BADGE
-------------------------------- */

const badgeStyle =
  document.createElement("style");

badgeStyle.textContent = `

/* =========================================
   ATELIER THEME PRODUCT BADGE CSS
========================================= */
:host {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  pointer-events: none !important;
}

.product-badges {
  --badge-inset: max(
    var(--padding-xs),
    calc(
      (var(--border-radius) + var(--padding-xs))
      * (1 - cos(45deg))
    )
  );

  position: absolute;
  z-index: var(--layer-flat);
}


/* TOP LEFT */

.product-badges--top-left {
  top: clamp(8px, 0.65vw, 12px);
  left: clamp(8px, 0.65vw, 12px);
}


/* BOTTOM LEFT */

.product-badges--bottom-left {
  bottom: calc(
    var(--badge-inset) + var(--padding-block-start)
  );

  left: calc(
    var(--badge-inset) + var(--padding-inline-start)
  );
}


/* TOP RIGHT */

.product-badges--top-right {
  top: calc(
    var(--badge-inset) + var(--padding-block-start)
  );

  right: calc(
    var(--badge-inset) + var(--padding-inline-start)
  );
}


/* ACTUAL BADGE */

.product-badges__badge {
  --badge-font-size: var(--font-size--xs);

  display: flex;

  align-items: center;
  justify-content: center;
  text-align: center;

  color: var(--color-foreground);
  background: var(--color-background);

  font-size: var(--badge-font-size);
  font-family: var(--badge-font-family);
  font-weight: var(--badge-font-weight);
  text-transform: var(--badge-text-transform);

  border-radius: var(--badge-border-radius);
}


/* RECTANGLE */

.product-badges__badge--rectangle {
  padding-block: var(--badge-rectangle-padding-block);
  padding-inline: var(--badge-rectangle-padding-inline);
}

`;

shadow.appendChild(
  badgeStyle
);

shadow.appendChild(
  badgeContainer
);


    /* --------------------------------
       MEDIA POSITIONING PARENT
    -------------------------------- */

    if (
      window.getComputedStyle(media).position === "static"
    ) {

      media.style.setProperty(
        "position",
        "relative",
        "important"
      );

    }


    /* --------------------------------
       INSERT BADGE
    -------------------------------- */

    media.insertBefore(
      wrapper,
      media.firstChild
    );


  } catch (error) {

    console.log(
      "Wishlist badge error:",
      error
    );

  } finally {

    delete wishlistBadgeLoading[handle];

  }

}
function enhanceWishlist(){

document.querySelectorAll(".wls-card").forEach(card=>{

// if(card.dataset.grablisDone) return;

/* -----------------------------
Product Handle
------------------------------ */

const link =
card.querySelector(".wls-card-title a");

if(!link) return;

const handle =
link.getAttribute("href")
.replace("/products/","")
.split("?")[0];

/* -----------------------------
PRODUCT BADGE
------------------------------ */

loadWishlistBadge(
  card,
  handle
);

/* -----------------------------
IMAGE
------------------------------ */

const media =
card.querySelector(".wls-card-media");

if(media){

if (media && !media.querySelector(".gr-qv")) {

    media.insertAdjacentHTML(
        "beforeend",
`
<div class="gr-qv">

<button class="bsqv_btn" data-product-handle="${handle}">
<svg xmlns="http://www.w3.org/2000/svg"
width="18"
height="18"
viewBox="0 0 24 24"
fill="none"
stroke="currentColor"
stroke-width="1.8"
stroke-linecap="round"
stroke-linejoin="round">

<path d="M1 12C3.5 7.5 7.5 5 12 5s8.5 2.5 11 7c-2.5 4.5-6.5 7-11 7S3.5 16.5 1 12z"/>

<circle cx="12" cy="12" r="2.5"/>

</svg>
</button>

</div>
`
);

}

}

/* -----------------------------
Rating Placeholder
------------------------------ */

const title =
card.querySelector(".wls-card-title");

if(title){

if (
    title &&
    !card.querySelector(".jdgm-badge-placeholder")
){

title.insertAdjacentHTML(
"beforebegin",
`
<div class="jdgm-badge-placeholder"
data-handle="${handle}">
</div>
`
);

}

}

/* -----------------------------
   DISCOUNT BADGE
------------------------------ */

const priceBox = card.querySelector(".wls-card-price");

if (priceBox) {

  const salePrice = priceBox.querySelector(".wls-price-sale");
  const comparePrice = priceBox.querySelector(".wls-compare-price");

  /* Remove old "Save XX%" text */
  const saveAmount = card.querySelector(".wls-save-amount");

  if (saveAmount) {
    saveAmount.remove();
  }

  if (salePrice && comparePrice) {

    const saleText = salePrice.textContent.replace(/[^\d]/g, "");
    const compareText = comparePrice.textContent.replace(/[^\d]/g, "");

    const sale = parseInt(saleText, 10);
    const compare = parseInt(compareText, 10);

    if (
      !isNaN(sale) &&
      !isNaN(compare) &&
      compare > sale
    ) {

      const discountPercent =
        Math.round(((compare - sale) / compare) * 100);

      let discountBadge =
        priceBox.querySelector(".gr-wishlist-discount");

      /* Create badge only once */
      if (!discountBadge) {

        discountBadge =
          document.createElement("span");

        discountBadge.className =
          "gr-wishlist-discount";

        priceBox.appendChild(
          discountBadge
        );

      }

      discountBadge.textContent =
        discountPercent + "% OFF";

    }
  }
}

});

renderJudgeMe();

// async function loadDescriptions(){

// document.querySelectorAll(".wls-card").forEach(async card=>{

// const link = card.querySelector(".wls-card-title a");

// if(!link) return;

// const handle = link.href.split("/products/")[1].split("?")[0];

// if(card.dataset.descLoaded) return;

// card.dataset.descLoaded = "loading";

// try{

// let product;

// if(productCache[handle]){

//     product = productCache[handle];

// }else{

//     const res = await fetch("/products/"+handle+".js");

//     if(!res.ok) return;

//     product = await res.json();

//     productCache[handle] = product;

// }

// let text = "";

// if(product.description){

//     const temp = document.createElement("div");

//     temp.innerHTML = product.description;

//     const firstParagraph = temp.querySelector("p");

//     if(firstParagraph){

//         text = firstParagraph.textContent.trim();

//     }else{

//         text = temp.textContent.trim();

//     }

// }

// if(!text){

//     text = "Premium quality t-shirt with comfortable fit.";

// }

// text = text.replace(/\s+/g," ");

// text = text.substring(0,65);

// const price =
// card.querySelector(".wls-card-price");

// card.dataset.descLoaded = "done";

// card.querySelectorAll(".gr-description").forEach((el,index)=>{

//     if(index>0) el.remove();

// });

// if(
//     price &&
//     !card.querySelector(".gr-description")
// ){

// price.insertAdjacentHTML(
// "beforebegin",
// `
// <p class="gr-description">
// ${text}
// </p>
// `
// );

// }

// }catch(e){

// console.log(e);

// }

// });

// }

// loadDescriptions();

}

/* -----------------------------
Judge.me
------------------------------ */

function renderJudgeMe(){

  document
    .querySelectorAll(".jdgm-badge-placeholder")
    .forEach(el => {

      /* Already loaded or currently loading */
      if (
        el.dataset.jdgmLoading === "true" ||
        el.dataset.jdgmLoaded === "true"
      ) {
        return;
      }

      const handle = el.dataset.handle;

      if (!handle) return;

      /* Lock this exact placeholder BEFORE fetch */
      el.dataset.jdgmLoading = "true";

      /* Cached badge */
      if (badgeCache[handle]) {

        el.innerHTML = badgeCache[handle];

        el.dataset.jdgmLoaded = "true";
        el.dataset.jdgmLoading = "false";

        return;
      }

      fetch("/products/" + handle)

        .then(r => r.text())

        .then(html => {

          const parser = new DOMParser();

          const doc =
            parser.parseFromString(html, "text/html");

          const badge =
            doc.querySelector(
              ".jdgm-widget.jdgm-preview-badge"
            );

          if (!badge) return;

          badgeCache[handle] =
            badge.outerHTML;

          /* Insert ONLY ONCE */
          if (
            el.dataset.jdgmLoaded !== "true"
          ) {

            el.innerHTML =
              badgeCache[handle];

            el.dataset.jdgmLoaded =
              "true";
          }

        })

        .catch(error => {

          console.log(
            "Judge.me badge error:",
            error
          );

        })

        .finally(() => {

          el.dataset.jdgmLoading =
            "false";

        });

    });

}

enhanceWishlist();

const observer = new MutationObserver(() => {
    requestAnimationFrame(() => {
        enhanceWishlist();
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

})();










